import Moment from 'moment';
import {
  LOG_IN,
  LOGGED_IN,
  LOG_OUT,
  LOGIN_ERROR
} from '../constants/ActionTypes'


const initialState =  {username: null, roles:null, isAdministrator:false, token: null, isAuthenticating:false, error: null, expirationTime:null}   

const user = (state = initialState, action) => {  
      
  switch (action.type) {
    case LOG_IN: {             
        state = {...state,  server : action.server, site : action.site, username: action.username, isAuthenticating : true, error : null, expirationTime : null};                  
        break;
    }
    case LOGGED_IN:{                              
        state = {...state, 
            username: action.username, 
            roles:action.roles,                         
            token: action.token, 
            isAuthenticating : false, 
            error : null, 
            expirationTime : Moment().add(3, 'hours').format("MMMM Do YYYY, h:mm:ss a")}                 
        break;  
    }
    case LOG_OUT: {        
        state = {};
        break;  
    }
    case LOGIN_ERROR: {       
        state = {...state, username: null, roles:null, isAdministrator:false, token: null, isAuthenticating:false, error: null, expirationTime:null}               
        break;
    }
    default:
        break;
  }
  return state
}

export default user



// WEBPACK FOOTER //
// ./src/reducers/login.js